import { cn } from '@/lib/utils'
import { GraphDownIcon, GraphUpIcon } from '@/components/dashboard/icons'

interface StatCardProps {
	title: string
	value: string
	decimals?: string
	percent?: string
	trend?: 'up' | 'down'
	highlight?: boolean
}

export function StatCard({ title, value, decimals, percent, trend = 'up', highlight = false }: StatCardProps) {
	return (
		<div className='flex min-w-0 flex-1 flex-col gap-3 rounded-[14px] border border-border bg-secondary p-3'>
			<div className='flex items-center justify-between px-1'>
				<span className='text-base font-medium tracking-[-0.24px] text-foreground'>{title}</span>
				{percent && (
					<span className={cn('flex items-center gap-1 text-sm font-semibold tracking-[-0.21px]', trend === 'down' ? 'text-destructive' : 'text-primary')}>
						{trend === 'down' ? <GraphDownIcon className='h-[18px] w-[18px]' /> : <GraphUpIcon className='h-[18px] w-[18px]' />}
						{percent}
					</span>
				)}
			</div>

			<div className='flex items-center justify-center rounded-[10px] bg-background py-4'>
				{highlight ? (
					<span className='text-2xl font-semibold tracking-[-0.12px] text-primary'>{value}</span>
				) : (
					<span className='text-2xl font-semibold tracking-[-0.12px] text-foreground'>
						{value}
						{decimals && <span className='text-base text-muted-foreground'>{decimals}</span>}
					</span>
				)}
			</div>
		</div>
	)
}
